import React from 'react';
import './AdminSidebar.css';

function AdminSidebar({ currentView, setCurrentView, onLogout, collapsed, setCollapsed }) {
  return (
    <>
      {/* ✅ Hamburger button — always visible when sidebar is hidden */}
      {collapsed && (
        <button
          className="sidebar-open-btn"
          onClick={() => setCollapsed(false)}
          title="Open Sidebar"
        >
          ☰
        </button>
      )}

      <aside className={`admin-sidebar ${collapsed ? 'sidebar-collapsed' : ''}`}>
        {/* ✅ Close (X) button — sticky so it stays visible when scrolling */}
        <button
          className="sidebar-close-btn"
          onClick={() => setCollapsed(true)}
          title="Close Sidebar"
        >
          ✕
        </button>

        <div className="admin-brand">
          <h2>I'm <span className="brand-accent">Selling</span></h2>
          <span className="admin-badge">ADMIN</span>
        </div>
      
        <nav className="admin-nav">
          <h3 className="nav-section-title">MAIN</h3>
          <button 
            className={`nav-item ${currentView === 'admin' ? 'active' : ''}`}
            onClick={() => setCurrentView('admin')} 
          >
            <span className="nav-icon">👑</span> 
            Super Admin
          </button>
          <button 
            className={`nav-item ${currentView === 'overview' ? 'active' : ''}`}
            onClick={() => setCurrentView('overview')}
          >
            <span className="nav-icon">📊</span>
            Dashboard
          </button>
          <button 
            className={`nav-item ${currentView === 'products' ? 'active' : ''}`}
            onClick={() => setCurrentView('products')}
          >
            <span className="nav-icon">📦</span>
            Products
          </button>
          <button 
            className={`nav-item ${currentView === 'promotions' ? 'active' : ''}`}
            onClick={() => setCurrentView('promotions')}
          >
            <span className="nav-icon">🎁</span>
            Promotions
          </button>
          <button 
            className={`nav-item ${currentView === 'users' ? 'active' : ''}`}
            onClick={() => setCurrentView('users')}
          >
            <span className="nav-icon">👥</span>
            Users
          </button>
          <button 
            className={`nav-item ${currentView === 'referrals' ? 'active' : ''}`}
            onClick={() => setCurrentView('referrals')}
          >
            <span className="nav-icon">🎁</span>
            Referrals
          </button>

          <h3 className="nav-section-title">MANAGEMENT</h3>
          <button 
            className={`nav-item ${currentView === 'shops' ? 'active' : ''}`}
            onClick={() => setCurrentView('shops')}
          >
            <span className="nav-icon">🏪</span>
            Shops
          </button>
          <button 
            className={`nav-item ${currentView === 'categories' ? 'active' : ''}`}
            onClick={() => setCurrentView('categories')}
          >
            <span className="nav-icon">📁</span>
            Categories
          </button>
          <button 
            className={`nav-item ${currentView === 'jobs' ? 'active' : ''}`}
            onClick={() => setCurrentView('jobs')}
          >
            <span className="nav-icon">💼</span>
            Jobs
          </button>
          <button 
            className={`nav-item ${currentView === 'reviews' ? 'active' : ''}`}
            onClick={() => setCurrentView('reviews')}
          >
            <span className="nav-icon">💬</span>
            Reviews
          </button>
          <button 
            className={`nav-item ${currentView === 'analytics' ? 'active' : ''}`}
            onClick={() => setCurrentView('analytics')}
          >
            <span className="nav-icon">📈</span>
            Analytics
          </button>

          {/* ✅ User Communications */}
          <button 
            className={`nav-item ${currentView === 'communications' ? 'active' : ''}`}
            onClick={() => setCurrentView('communications')}
          >
            <span className="nav-icon">📨</span>
            User Communications
          </button>

          {/* ✅ AI ChatBot */}
          <button 
            className={`nav-item ${currentView === 'chatbot' ? 'active' : ''}`}
            onClick={() => setCurrentView('chatbot')}
          >
            <span className="nav-icon">🤖</span>
            AI Assistant
          </button>

          <h3 className="nav-section-title">SETTINGS</h3>
          <button className="nav-item">
            <span className="nav-icon">⚙️</span>
            Settings
          </button>
          <button className="nav-item">
            <span className="nav-icon">🔔</span>
            Notifications
          </button>
        </nav>

        <div className="sidebar-footer">
          <button className="nav-item logout-btn" onClick={onLogout}>
            <span className="nav-icon">🚪</span>
            Logout
          </button>
        </div>
      </aside>

      {/* ✅ Overlay for mobile — click to close */}
      {!collapsed && (
        <div className="sidebar-overlay" onClick={() => setCollapsed(true)} />
      )}
    </>
  );
}

export default AdminSidebar;



















// import React from 'react';
// import './AdminSidebar.css';

// function AdminSidebar({ currentView, setCurrentView, onLogout }) {
//   return (
//     <aside className="admin-sidebar">
//       <div className="admin-brand">
//         <h2>I'm <span className="brand-accent">Selling</span></h2>
//         <span className="admin-badge">ADMIN</span>
//       </div>
      
//       <nav className="admin-nav">
//         <h3 className="nav-section-title">MAIN</h3>
//         <button 
//           className={`nav-item ${currentView === 'admin' ? 'active' : ''}`}
//           onClick={() => setCurrentView('admin')}
//         >
//           <span className="nav-icon">👑</span>
//           Super Admin
//         </button>
//         <button 
//           className={`nav-item ${currentView === 'overview' ? 'active' : ''}`}
//           onClick={() => setCurrentView('overview')}
//         >
//           <span className="nav-icon">📊</span>
//           Dashboard
//         </button>
//         <button 
//           className={`nav-item ${currentView === 'products' ? 'active' : ''}`}
//           onClick={() => setCurrentView('products')}
//         >
//           <span className="nav-icon">📦</span>
//           Products
//         </button>
//         <button 
//           className={`nav-item ${currentView === 'promotions' ? 'active' : ''}`}
//           onClick={() => setCurrentView('promotions')}
//         >
//           <span className="nav-icon">🎁</span>
//           Promotions
//         </button>
//         <button 
//           className={`nav-item ${currentView === 'users' ? 'active' : ''}`}
//           onClick={() => setCurrentView('users')}
//         >
//           <span className="nav-icon">👥</span>
//           Users
//         </button>
//         <button 
//           className={`nav-item ${currentView === 'referrals' ? 'active' : ''}`}
//           onClick={() => setCurrentView('referrals')}
//         >
//           <span className="nav-icon">🎁</span>
//           Referrals
//         </button>

//         <h3 className="nav-section-title">MANAGEMENT</h3>
//         <button 
//           className={`nav-item ${currentView === 'shops' ? 'active' : ''}`}
//           onClick={() => setCurrentView('shops')}
//         >
//           <span className="nav-icon">🏪</span>
//           Shops
//         </button>
//         <button 
//           className={`nav-item ${currentView === 'categories' ? 'active' : ''}`}
//           onClick={() => setCurrentView('categories')}
//         >
//           <span className="nav-icon">📁</span>
//           Categories
//         </button>
//         <button 
//           className={`nav-item ${currentView === 'jobs' ? 'active' : ''}`}
//           onClick={() => setCurrentView('jobs')}
//         >
//           <span className="nav-icon">💼</span>
//           Jobs
//         </button>
//         <button 
//           className={`nav-item ${currentView === 'reviews' ? 'active' : ''}`}
//           onClick={() => setCurrentView('reviews')}
//         >
//           <span className="nav-icon">💬</span>
//           Reviews
//         </button>
//         <button 
//           className={`nav-item ${currentView === 'analytics' ? 'active' : ''}`}
//           onClick={() => setCurrentView('analytics')}
//         >
//           <span className="nav-icon">📈</span>
//           Analytics
//         </button>

//         {/* ✅ User Communications */}
//         <button 
//           className={`nav-item ${currentView === 'communications' ? 'active' : ''}`}
//           onClick={() => setCurrentView('communications')}
//         >
//           <span className="nav-icon">📨</span>
//           User Communications
//         </button>

//         {/* ✅ AI ChatBot */}
//         <button 
//           className={`nav-item ${currentView === 'chatbot' ? 'active' : ''}`}
//           onClick={() => setCurrentView('chatbot')}
//         >
//           <span className="nav-icon">🤖</span>
//           AI Assistant
//         </button>

//         <h3 className="nav-section-title">SETTINGS</h3>
//         <button className="nav-item">
//           <span className="nav-icon">⚙️</span>
//           Settings
//         </button>
//         <button className="nav-item">
//           <span className="nav-icon">🔔</span>
//           Notifications
//         </button>
//       </nav>

//       <div className="sidebar-footer">
//         <button className="nav-item logout-btn" onClick={onLogout}>
//           <span className="nav-icon">🚪</span>
//           Logout
//         </button>
//       </div>
//     </aside>
//   );
// }

// export default AdminSidebar;